import { useChunkLoadRecovery } from '../hooks';

/**
 * 라우팅 중 청크 로드 실패 자동복구를 활성화하는 마운트 지점(ZEP-655).
 * 렌더 산출물은 없다 — _app 에 한 번만 마운트한다.
 */
export const ChunkLoadRecovery = () => {
  useChunkLoadRecovery();
  return null;
};